import React, { useState, useEffect } from 'react';
import Footer from '../../layout/Footer';
import { Container, Row, Col, Card, Form, Table } from 'react-bootstrap';
// Datatable
import JSZip from 'jszip';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";
import DataTable from 'datatables.net-dt';

import BranchWiseStockReportTableData from "./branch-wise-stock-report-table-data.json";
import FormInputs from '../../../Utils/FormInputs';

export default function BranchWiseStockReport() {
    // datatable
    const [branchWiseStockReportData] = useState(BranchWiseStockReportTableData);
  DataTable.Buttons.jszip(JSZip);
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  useEffect(() => {
    if (!$.fn.dataTable.isDataTable('#mainDatatableBWSReport')) {
      $('#mainDatatableBWSReport').DataTable({
        dom: "flrtip",
        language: {
          search: '',
          searchPlaceholder: "Search...",
          paginate: {
            previous: '«',
            next: '»'
          },
        }
      });
    }
  }, []);

  const initialInputData = {
    select_time_duration: '',
}

const [inputData, setInputData] = useState(initialInputData);
const handleBranchWiseStockReportInputChange = (index, field, value) => {
    setInputData({ ...inputData, [field]: value });
};
const handleBranchWiseStockReportSubmit = (e) => {
    e.preventDefault();
};
const branchWiseStockReportRows = [
    {
        rowClass: 'row-cols-xxl-5 row-cols-xl-4 row-cols-lg-3 row-cols-sm-2 row-cols-1 justify-content-center align-items-center',
        columns: [
            {
                size: {}, label: 'Time Duration', type: 'select', name: 'time_duration', id: 'timeDuration', value: inputData.time_duration, inputParentClass: 'custom-form-input-sm', errormsg: '',
                options: [
                    { value: '', label: 'All time' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                    // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                ],
            },
            {
                size: {}, label: 'Product Category', type: 'select', name: 'product_category', id: 'productCategory', value: inputData.product_category, inputParentClass: 'custom-form-input-sm', errormsg: '',
                options: [
                    { value: '', label: 'Select product category' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                    // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                ],
            },
            {
                size: {}, label: 'Month Time Duration', type: 'select', name: 'month_time_duration', id: 'monthTimeDuration', value: inputData.month_time_duration, inputParentClass: 'custom-form-input-sm', errormsg: '',
                options: [
                    { value: '', label: 'Select month time' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                    // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                ],
            },
            {
                size: {}, label: 'GL Year Time Duration', type: 'select', name: 'gl_year_time_duration', id: 'glYearTimeDuration', value: inputData.gl_year_time_duration, inputParentClass: 'custom-form-input-sm', errormsg: '',
                options: [
                    { value: '', label: 'Select year time duration' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                    // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                ],
            },
            {
                size: {}, label: 'GLF Year Time Duration', type: 'select', name: 'glf_year_time_duration', id: 'glfYearTimeDuration', value: inputData.glf_year_time_duration, inputParentClass: 'custom-form-input-sm', errormsg: '',
                options: [
                    { value: '', label: 'Select year time duration' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                    // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                ],
            },
        ]
    },
    {
        columns: [
            { size: { sm: 12 }, tag: 'h5', type: 'normaltext', class: 'mb-3 fs-16 text-end', text: 'Total No of Products : 47566', },
        ]
    }
];
const branchWiseStockReportButtons = [];

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-sm-flex justify-content-between align-items-center mb-3">
                                            <Card.Title className='mb-sm-0'>Branch Wise Stock Report</Card.Title>
                                            <Form className='min-w'>
                                                <Form.Control type="date" placeholder="Enter name" size='sm' name='salesInvoiceReturnDate' id='salesInvoiceReturnDate' />
                                            </Form>
                                        </div>

                                        <FormInputs Buttons={branchWiseStockReportButtons} rows={branchWiseStockReportRows} handleInputChange={handleBranchWiseStockReportInputChange} handleSubmit={handleBranchWiseStockReportSubmit} />

                                        <Table responsive bordered id='mainDatatableBWSReport'>
                                            <thead className='table-light'>
                                                <tr>
                                                    <th>Sr No.</th>
                                                    <th>Product Name</th>
                                                    <th>Category Name</th>
                                                    <th>Vendor</th>
                                                    <th>BD Enterprise In-store Retail</th>
                                                    <th>BD Enterprise In-store Consumable</th>
                                                    <th>BD Enterprise On-floor Retail</th>
                                                    <th>BD Enterprise On-floor Consumable</th>
                                                    <th>NFS Adajan In-store Retail</th>
                                                    <th>NFS Adajan InStore Consuma</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {branchWiseStockReportData.map((data, i) =>
                                                    <tr key={i}>
                                                        <td>{data.srNo}</td>
                                                        <td>{data.productName}</td>
                                                        <td>{data.categoyrName}</td>
                                                        <td>{data.vendor}</td>
                                                        <td>{data.bdEnterpriseInstoreRetail}</td>
                                                        <td>{data.bdEnterpriseInstoreConsumable}</td>
                                                        <td>{data.bdEnterpriseOnfloorRetail}</td>
                                                        <td>{data.bdEnterpriseOnfloorConsumable}</td>
                                                        <td>{data.nfsAdajanInstoreRetail}</td>
                                                        <td>{data.nfsAdajanInStoreConsuma}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
